import React, {forwardRef} from 'react';
import {TextProps} from '../Text';
import {NoteBodyView} from './Note.styles';
import {useNoteContext} from './useNote';
import {NoteTitle} from './NoteTitle';
import {VStack} from '../Stack';
import {useSize} from '@packages/utilities/styled';

export type NoteBodyProps = TextProps;

export const NoteBody = forwardRef<HTMLElement, NoteBodyProps>(
  ({children, ...props}: NoteBodyProps, ref) => {
    const {inlineTitle} = useNoteContext();

    const size = useSize();

    if (inlineTitle !== undefined) {
      return (
        <VStack spacing={size === 'x-large' ? 2 : 1}>
          <NoteTitle>{inlineTitle}</NoteTitle>
          <NoteBodyView ref={ref} {...props}>
            {children}
          </NoteBodyView>
        </VStack>
      );
    }

    return (
      <NoteBodyView ref={ref} {...props}>
        {children}
      </NoteBodyView>
    );
  }
);

NoteBody.displayName = 'NoteBody';
NoteBody.toString = NoteBodyView.toString;

export default NoteBody;
